import React from "react";
import IconChip from "../../../Resources/svg/Icons/IconChip";

interface Props {
  label: string;
  handleCloseChip: any;
  variant: string;
}

const Chip = ({ label, handleCloseChip, variant }: Props) => {
  return (
    <div className="chip-box">
      <span
        className={`chip-box__label ${
          variant == "filtro" ? "is-filter" : "is-asesor"
        }`}
      >
        {label}
      </span>
      <IconChip onClick={handleCloseChip} />
    </div>
  );
};

export default Chip;
